export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification, Message} from 'kpc';
import {bind} from 'kpc';

export default class extends Component {
    static template = template;
    
    @bind
    showNotification() {
        Notification.info({
            title: '事件通知',
            content: '点击通知或等待自动关闭，查看页面信息提示',
            onClick: (e) => {
                Message.info('你点击了通知');
            },
            onClose: () => {
                Message.warning('通知已关闭');
            },
            className: 'event-test'
        });
    }
}